export const mailTemplateApi = {

    getAll() {
        return axios.get('/api/mail-templates', {
            'Content-Type': 'application/json'
        })
    },

}
